import { Text, Box } from '@chakra-ui/react';
import { MdOpenInNew as OpenInNewIcon } from 'react-icons/md';
import { ImportSource } from '@/utils/recipeSource';

interface RecipeSourceBadgeProps {
  source: ImportSource;
  variant: 'hero' | 'sidebar';
}

export default function RecipeSourceBadge({ source, variant }: RecipeSourceBadgeProps) {
  if (variant === 'hero') {
    return (
      <a
        href={source.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', textDecoration: 'none', marginBottom: '8px' }}
      >
        <Text
          fontFamily="body"
          fontWeight="400"
          fontSize="12px"
          color="rgba(255,255,255,0.75)"
        >
          Imported from {source.label}
        </Text>
        <Box color="rgba(255,255,255,0.75)" display="flex" alignItems="center">
          <OpenInNewIcon size={11} />
        </Box>
      </a>
    );
  }

  return (
    <a
      href={source.url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', textDecoration: 'none' }}
    >
      <Text
        fontFamily="body"
        fontWeight="500"
        fontSize="13px"
        color="accent.secondary"
      >
        {source.label}
      </Text>
      <Box color="accent.secondary" display="flex" alignItems="center">
        <OpenInNewIcon size={12} />
      </Box>
    </a>
  );
}
